import { NoSsr, Stack, styled, Box } from "@mui/material";
import HeaderComponent from "../header";
import FooterComponent from "../footer";
import PropTypes from "prop-types";

export const MainLayoutRoot = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  height: "100vh",
}));

export const LandingLayout = ({ children, configData, landingPageData }) => {
  return (
    <MainLayoutRoot justifyContent="space-between" sx={{ display: "flex", flexDirection: "column" }}>
      <header style={{ flexShrink: 0 }}>
        <HeaderComponent configData={configData} />
      </header>
      <Box sx={{ flex: "1 1 auto", width: "100%" }}>
      {children}
      </Box>
      <footer style={{ flexShrink: 0, marginTop: "auto" }}>
        <FooterComponent
          configData={configData}
          landingPageData={landingPageData}
        />
      </footer>
    </MainLayoutRoot>
  );
};

LandingLayout.propTypes = {
  children: PropTypes.node,
};
